module.exports = __webpack_public_path__ + "img/menu-extra.4083636a.png";